import * as React from 'react';
import { GroupByPanelTexts } from './group-by-panel-texts';
import { SelectionFieldItem, SelectionValue } from '../types-fields';
import { DropdownField, mapToMenuItem } from 'app/area/reports/components/dropdown-field';
import { SelectItem } from 'app/area/reports/types';

import styles from './group-by-sort.scss';

interface GroupBySortComponentProps {
  item: SelectionFieldItem;
  isSingleElement: boolean;
  sortOrderTypes: SelectItem[];

  onChange: (value: SelectionValue) => void;

  translation: GroupByPanelTexts;
}

class GroupBySortComponent extends React.PureComponent<GroupBySortComponentProps, {}> {

  private handleSortOrderChange = (sortItem: SelectItem) => {
    this.props.onChange({
      ...this.props.item.value,
      sortOrderType: sortItem
    });
  };

  public render(): JSX.Element {
    const {
      item, isSingleElement, sortOrderTypes, translation
    } = this.props;

    const sortItems = sortOrderTypes.map(s => mapToMenuItem(s, () => this.handleSortOrderChange(s)));
    const selectedItem = !!item.value && !!item.value.sortOrderType && sortItems.find(i =>
      i.value === String(item.value.sortOrderType.value));

    return !!item.selectionTypes && <DropdownField
      className={!isSingleElement ? styles.sortArea : undefined}
      title={translation.group_by_sort}
      selectedItem={selectedItem || sortItems[0]}
      options={sortItems}
    />;
  }
}

export const GroupBySort = GroupBySortComponent;
